import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { IEntity } from 'interfaces/entity';
import React from 'react';

interface IProps {
  areas: IEntity[];
  value: any;
  changeValue: any;
  subTab?: boolean;
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: ({ subTab }: Partial<IProps>) => subTab ? '#E6E6E6 ' : theme.palette.secondary.main,
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  selected: {
    backgroundColor: ({ subTab }: Partial<IProps>) => subTab ? '#424242' : theme.palette.primary.main,
    color: theme.palette.common.white
  },
  tab: {
    fontWeight: 700,
    textTransform: 'none',
    // color: ({ subTab }: Partial<IProps>) => subTab ? '#8C8C8C' : 'inherit'
  }
}));

const AreaBar = ({ changeValue, areas, value, subTab }: IProps) => {
  const classes = useStyles({ subTab });

  return (
    <Tabs
      value={value}
      onChange={changeValue}
      variant="scrollable"
      scrollButtons="on"
      className={classes.root}
    >
      {areas.map((tab, index) => (
        <Tab
          key={`entity-tab-${tab.id}`}
          label={tab.name}
          classes={{
            root: classes.tab,
            selected: classes.selected
          }}
        />
      ))}
    </Tabs>
  );
};

export default AreaBar;